import { yupResolver } from "@hookform/resolvers/yup";
import FormButtons, { FormButtonInterface } from "components/forms/buttons";
import { CancelButton, SubmitButton } from "components/forms/buttons.utils";
import Form from "components/forms/form";
import Col from "components/grid/col";
import Grid from "components/grid/grid";
import Row from "components/grid/row";
import { FunctionComponent } from "react";
import { useForm } from "react-hook-form";
import * as yup from "yup";
import { Locale } from "models/locale";
import { faSave } from "components/icon-library";
import { OptionInterface } from "components/forms/inputs/dropdown.styles";
import { getLanguageOptions } from "components/forms/inputs/dropdown.utils";
import { useLocales } from "stores/hooks/locale";
import { useTranslate } from "stores/hooks/translation";
import Dropdown from "components/forms/inputs/dropdown";
import { ListUser } from "models/list-user";

interface EditLocaleModalFormProps {
  onSubmit: (locale: Locale) => Promise<void>;
  onClose: () => Promise<void>;
  user: ListUser;
}

const EditLocaleModalForm: FunctionComponent<EditLocaleModalFormProps> = ({
  onClose,
  onSubmit,
  user,
}) => {
  const locales = useLocales();
  const translate = useTranslate();

  const schema = yup
    .object({
      locale: yup.string().validateOneOf(locales).validateRequired(),
    })
    .required();

  const methods = useForm({
    mode: "onSubmit",
    reValidateMode: "onChange",
    resolver: yupResolver(schema),
    defaultValues: {
      locale: user.locale,
    },
  });

  const handleSubmit = async (values: any) => {
    const { locale } = values;
    onSubmit(locale);
  };

  const buttons: FormButtonInterface[] = [
    { ...CancelButton, onClick: onClose },
    { ...SubmitButton, postIcon: faSave },
  ];

  const localeOptions: OptionInterface[] = getLanguageOptions(
    locales,
    translate,
  );

  return (
    <Form methods={methods} onSubmit={handleSubmit}>
      <Grid>
        <Row>
          <Col>
            <Dropdown
              name="locale"
              label="Kieli"
              options={localeOptions}
              required
            />
          </Col>
        </Row>
        <FormButtons buttons={buttons} />
      </Grid>
    </Form>
  );
};

export default EditLocaleModalForm;
